import React from "react";

const DialogContentAssignedIn = ({ selectedActivity }) => {
    return (
        <div>
            Esta actividad fue asignada en los siguientes cursos:
            <ul>
                {selectedActivity.deleteInformation?.course_list.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
            <br />
        </div>
    );
};

export default DialogContentAssignedIn;
